import HttpClient from "../../utils/http";
import { app_users, app_users_download_list, app_users_list, download_users_data,userForMerchantList } from "../constants/api_endpoints";

export function getAppUsers({
  size,
  page,
  ageFrom,
  ageTo,
  gender_id,
  occupationId,
  incomeId,
  educationId,
  stateId,
  keyword,
  isSubscribed,
  sortBy,
  sortOrder,
  startDate,
  endDate,
  city,
  district,
  orgId
}: {
  size: number | null;
  page: number | null;
  ageFrom?: number | null;
  ageTo?: number | null;
  gender_id?: number | null;
  occupationId?: number | null;
  incomeId?: number | null;
  educationId?: number | null;
  stateId?: number | null;
  keyword?: string;
  isSubscribed: boolean;
  sortBy?: string | null;
  sortOrder: string | null;
  startDate:string | null;
  endDate:string | null;
  city: number | null;
  district: number | null;
  orgId?: number | null;
}) {
  let url = app_users_list + `?page=${page}&size=${size}`;
  if (ageFrom && ageTo) url += `&fromAge=${ageFrom}&toAge=${ageTo}`;
  if (gender_id) url += `&gender_id=${gender_id}`;
  if (occupationId) url += `&occupation=${occupationId}`;
  if (incomeId) url += `&currentIncome=${incomeId}`;
  if (educationId) url += `&education=${educationId}`;
  if (stateId) url += `&state=${stateId}`;
  if (keyword) url += `&keyword=${keyword}`;
  if (isSubscribed) url += `&isSubscribed=${isSubscribed}`;
  if (sortBy) url += `&sortBy=${sortBy}`;
  if (sortOrder) url += `&sortOrder=${sortOrder}`;
  if(startDate!=="" && endDate!=="") url +=`&dateFrom=${startDate}&dateTo=${endDate}`
  if (city !== null) url += `&city=${city}`
   if (district !== null) url += `&district=${district}`
  if (orgId) url += `&orgId=${orgId}`
  return HttpClient.get(url);
}

export function getUsersForMerchant({
  size,
  page,
  ageFrom,
  ageTo,
  gender_id,
  occupationId,
  incomeId,
  educationId,
  stateId,
  keyword,
  isSubscribed,
  sortOrder,
  startDate,
  endDate,
  city,
  district
}: {
  size: number | null;
  page: number | null;
  ageFrom?: number | null;
  ageTo?: number | null;
  gender_id?: number | null;
  occupationId?: number | null;
  incomeId?: number | null;
  educationId?: number | null;
  stateId?: number | null;
  keyword?: string;
  isSubscribed: boolean;
  sortOrder: string | null;
  startDate:string | null;
  endDate:string | null;
  city: number | null;
  district: number | null;
}) {
  let url = userForMerchantList  + `?page=${page}&size=${size}`;
  if (ageFrom && ageTo) url += `&fromAge=${ageFrom}&toAge=${ageTo}`;
  if (gender_id) url += `&gender_id=${gender_id}`;
  if (occupationId) url += `&occupation=${occupationId}`;
  if (incomeId) url += `&currentIncome=${incomeId}`;
  if (educationId) url += `&education=${educationId}`;
  if (stateId) url += `&state=${stateId}`;
  if (keyword) url += `&keyword=${keyword}`;
  if (isSubscribed) url += `&isSubscribed=${isSubscribed}`;
  if (sortOrder) url += `&sortOrder=${sortOrder}`;
  if(startDate!=="" && endDate!=="") url +=`&dateFrom=${startDate}&dateTo=${endDate}`
  if (city !== null) url += `&city=${city}`
   if (district !== null) url += `&district=${district}`
  return HttpClient.get(url);
}

export function getUsersDownloadList({
  page,
  size,
  dateFrom,
  dateTo,
  sortOrder,
  status,
  orgId
}: {
  page: number | null;
  size: number | null;
  dateFrom: string | null;
  dateTo: string | null;
  sortOrder:string;
  status:number | null;
  orgId?: number | null;
}) {
  console.log(dateFrom,dateTo,'dateFrom');

  let url = `${app_users_download_list}?page=${page}&size=${size}`;
  if (dateFrom && dateTo) url += `&fromDate=${dateFrom}&toDate=${dateTo}`;
  if (sortOrder) {
    url += `&sortOrder=${sortOrder}`;
  }
  if (status) url += `&status=${status}`;
  if (orgId) url += `&orgId=${orgId}`;
  return HttpClient.get(url);
}

export function downloadAppUsers({
  ageFrom,
  ageTo,
  gender_id,
  occupationId,
  incomeId,
  educationId,
  stateId,
  keyword,
  format,
  page,
  size,
  isSubscribed,
  sortBy,
  sortOrder,
  startDate,
  endDate,
  city

}: {
  format: string | null;
  ageFrom?: number | null;
  ageTo?: number | null;
  gender_id?: number | null;
  occupationId?: number | null;
  incomeId?: number | null;
  educationId?: number | null;
  stateId?: number | null;
  keyword?: string;
  page?: number;
  size?: number;
  isSubscribed: boolean;
  sortBy?: string | null;
  sortOrder: string | null;
  startDate:string | null;
  endDate:string | null;
  city: number | null;
}) {
  let url = `${app_users_list}?page=${page}&size=${size}&download=${true}&format=${format}`;
  if (ageFrom && ageTo) url += `&fromAge=${ageFrom}&toAge=${ageTo}`;
  if (gender_id) url += `&gender_id=${gender_id}`;
  if (occupationId) url += `&occupation=${occupationId}`;
  if (incomeId) url += `&currentIncome=${incomeId}`;
  if (educationId) url += `&education=${educationId}`;
  if (stateId) url += `&state=${stateId}`;
  if (keyword) url += `&keyword=${keyword}`;
  if (isSubscribed) url += `&isSubscribed=${isSubscribed}`;
  if (sortBy) url += `&sortBy=${sortBy}`;
  if (sortOrder) url += `&sortOrder=${sortOrder}`;
  if(startDate!=="" && endDate!=="") url +=`&dateFrom=${startDate}&dateTo=${endDate}`
  if (city !== null) url += `&city=${city}`
  // This just queues a background export task (see admin-user-service's
  // app-users-services.js) — it should always respond quickly. A timeout
  // keeps the UI's loading state from hanging indefinitely if it doesn't.
  return HttpClient.get(url, { timeout: 20000 });
}

export function appUsersService({
  userId,
  isBlocked,
  comments,
}: {
  comments: string;
  isBlocked: boolean;
  userId: number | null;
}) {
  let url = `${app_users}${userId}`;

  return HttpClient.patch(url, {
    isBlocked: isBlocked,
    comments: comments,
  });
}

export function deleteAppUser({
  userId,
  comments,
}: {
  comments: string;
  userId: number | null;
}) {
  let url = `${app_users}${userId}`;

  return HttpClient.delete(url, {
    data: {
      comments: comments,
    },
  });
}

export function getAppUsersById({ id }: { id: number | null }) {
  let url = `${app_users}${id}`;
  return HttpClient.get(url);
}

export function downloadAppUsersById({ id }: { id: number | null }) {
  let url = `${app_users}${id}?download=true&format=excel`;
  return HttpClient.get(url, {
    responseType: "blob",
  });
}

export function getAppUsersSummaryById({ id }: { id: number | null }) {
  let url = `${app_users}summary/${id}`;
  return HttpClient.get(url);
}

export function usersDownload({
  taskId, 
}: {
  taskId: number; 
}) {
  return HttpClient.get(
    `${download_users_data}?taskId=${taskId}`
  ,{ responseType: "blob" });
}